import { render, staticRenderFns } from "./lendersInfo.vue?vue&type=template&id=19a0f25e&scoped=true"
import script from "./lendersInfo.vue?vue&type=script&lang=js"
export * from "./lendersInfo.vue?vue&type=script&lang=js"
import style0 from "./lendersInfo.vue?vue&type=style&index=0&id=19a0f25e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a0f25e",
  null
  
)

export default component.exports